document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Close' : 'Menu';
    });
  }
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const price = document.querySelector('[data-price]');
    const button = document.querySelector('[data-add-button]');
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
      }
    });
  });
});
